import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 max-w-2xl" }
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-gray-600"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-3 text-gray-900"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-1 text-gray-600"
}

import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useEntitlements } from '@/composables/useEntitlements'


export default {
  __name: 'FeatureLocked',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { on, locked } = useEntitlements()

const key = computed(() => String(route.params.key || ''))
const info = computed(() => locked(key.value))
const title = computed(() => info.value?.name || 'This feature is not on your plan')

// Watching the key, not mounting, so /locked/a to /locked/b re-checks. This page
// is reached through nav and route guards only, never by a background request.
watch(
  key,
  value => {
    if (on(value)) router.replace('/')
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: title.value }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueWell, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                class: "h-8 w-8 text-gray-400 shrink-0",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(title.value), 1),
                (info.value?.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(info.value.description), 1))
                  : _createCommentVNode("", true),
                (info.value?.plan)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Included in the " + _toDisplayString(info.value.plan) + " plan.", 1))
                  : _createCommentVNode("", true),
                (info.value?.upgrade_line)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(info.value.upgrade_line), 1))
                  : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4 text-sm text-gray-500" }, "Contact support to change your plan.", -1))
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

}